<template>
  <div class="inline-filter" :class="{ [wc]: true }">
    <b-button
      class="filter-button mr-2"
      :variant="!activeFilter[pointer.value] ? 'success' : 'light'"
      @click="onSelectItem({})"
    >
      {{ $t('global.all')  }} {{ label }}
    </b-button>
    <b-button
      class="filter-button item mr-2"
      style="text-transform: uppercase !important"
      v-for="(item, index) in data.slice(0, data.length > 5 ? 5 : data.length)"
      :key="'filter-' + index"
      :variant="activeFilter[pointer.value] === item[pointer.value] ? 'success' : 'light'"
      @click="onSelectItem(item)"
    >
      {{ item[pointer.label] }}
    </b-button>
    <b-button
      v-if="activeFilter && activeFilter.index >= 5"
      class="filter-button mr-2"
      variant="success"
    >
      {{ activeFilter.name }}
    </b-button>
    <b-button
      v-if="data.length > 5"
      class="filter-button mr-2"
      style="position: relative"
      @click="showFilter = !showFilter"
      v-click-outside="hideFilter"
      variant="light"
    >
      <span class="text-uppercase">{{  $t('global.other') }}</span> <i class="ri-more-fill"></i>
      <div
        class="toggle-filter-content d-flex flex-column"
        :class="{ hide: showFilter === false }"
      >
        <b-button
          class="filter-button item mb-1"
          style="text-transform: uppercase !important"
          v-for="(item, index) in data.slice(5, data.length)"
          @click="onSelectItem(item)"
          :key="'filter-lainnya-' + index"
          :variant="
            activeFilter[pointer.value] === item[pointer.value] ? 'success' : 'light'
          "
        >
          {{ item[pointer.label] }}
        </b-button>
      </div>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "inline-filter",
  props: {
    data: {
      required: false,
      default: () => [],
    },
    label: {
      required: false,
      default: () => "",
    },
    pointer: {
      required: false,
      default: () => {
        return {
          label: "name",
          value: "id",
        };
      },
    },

    value: {
      required: false,
      default: () => null,
    },
    wc: {
      required: false,
      default: () => "",
    },
  },

  mounted() {
    if (this.value) {
      this.setDefaultValue(this.value)
    }
  },

  data() {
    return {
      activeFilter: {},
      showFilter: false,
    };
  },

  methods: {
    setDefaultValue(value) {
      let idx= this.data.findIndex( x=> x[this.pointer.value] === value)
      if (idx > -1) {
        this.activeFilter = this.data[idx]
      }
    },
    hideFilter() {
      this.showFilter = false;
    },

    onSelectItem(item) {
      let idx = this.data.findIndex(
        (x) => x[this.pointer.value] === item[this.pointer.value]
      );
      if (idx < 0) {
        this.activeFilter = {};
        this.$emit("change", {});
        return;
      }
      let selectedItem = this.data[idx];
      selectedItem.index = idx;
      this.activeFilter = selectedItem;
      this.$emit("change", selectedItem);
    },
  },
};
</script>

<style scoped>
.filter-button {
  border-radius: 8px;
  margin-bottom: 8px;
}

.filter-buton.item {
  text-transform: uppercase !important;
}
.toggle-filter {
  position: relative;
}

.toggle-filter-content {
  position: absolute;
  width: 10vw;
  top: calc(100% + 5px);
  z-index: 10;
  right: 0;
  border-radius: 10px;
  background-color: white;
  padding: 1.5em;
  min-width: 200px;
  max-height: 100vh;
  box-shadow: 8px 6px 6px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 8px 6px 6px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 8px 6px 6px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  visibility: visible;
  opacity: 1;
  overflow: hidden;
  border: 1px solid #cfcfcf59;
}

.toggle-filter-content.hide {
  max-height: 0px;
  visibility: hidden;
  transition: all 0.3s ease;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/base/component/inline-filter.vue